/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-template-curly-in-string */
import { Card, Col, Row, Badge, Modal, InputNumber, Form, Button, Image, Tooltip, Table, message, Tag } from 'antd'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { InfoCircleOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import Countdown from 'antd/lib/statistic/Countdown'
import isToday from 'dayjs/plugin/isToday'
import { useAppDispatch, useAppSelector } from '../../redux/reduxHooks'
import { customerInfoData } from '../../redux/reducers/customerInfo_reducer'
import { incrementShoppingCart, setItem } from '../../redux/reducers/cartItems_reducer'
import { ProductInfo, ShoppingCartItemType } from '../../models/shoppingCartItem'
import { homePageData } from '../../redux/reducers/homePage_reducer'
import { productInventoryColumns } from '../../data/tableColumns'
import { productSummary } from '../../api/response'
import { ProductSummaryTypes } from '../../models/productQuery'
import api from '../../config/api'
import { FormattedMessage } from 'react-intl'

const ProductName = styled.div`
  overflow: hidden;
  font-size: 0.9rem;
  line-height: 1rem;
  height: 2rem;
  font-weight: 400;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`
const Sku = styled.div`
  overflow: hidden;
  font-size: 0.7rem;
  color: gray;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const InfoCircleIconStyle = styled(InfoCircleOutlined)`
  font-size: 1rem;
  color: skyblue;
  &:hover {
    transform: scale(1.2);
  }
`

const StyledContent = styled.div`
  .ant-badge {
    width: 100%;
    min-height: 100%;
  }
`

const StyledCover = styled.div`
  .ant-image {
    width: 100%;
    height: 100%;
  }
  width: 100%;
  height: 10rem;
`

const H6 = styled.span`
  font-size: 0.8rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
`
const H6Price = styled.span`
  font-size: 0.9rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  color: black;
`
const H6PriceVIP = styled.span`
  font-size: 0.9rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  color: orange;
`
const H6PriceSpecial = styled.span`
  font-size: 0.9rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  color: red;
`
const H6PriceWholesale = styled.span`
  font-size: 0.9rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  color: blue;
`
const H6PriceTier = styled.span`
  font-size: 0.9rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  color: pink;
`

const H6PriceSymbol = styled.span`
  font-size: 0.7rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  margin-right: 2px;
  color: gray;
  line-height: 1;
`

const Img = styled(Image)`
  object-fit: contain;
  height: 80% !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
`

const validateMessages = {
  required: '${label} is required!',
  types: {
    number: '${label} is not a valid number!'
  },
  number: {
    range: '${label} must be between ${min} and ${max}'
  }
}

const Products: React.FC<{ data: ProductInfo; items: ShoppingCartItemType[] }> = (props) => {
  const {
    productId,
    name,
    image,
    tags,
    shippingName,
    priceUnderlined,
    finalPrice,
    finalPriceType,
    stock,
    specialToDate,
    barcode,
    stockVisible,
    specialStatus,
    specialFromDate,
    breakingStatus
  } = props.data
  const [items, setItems] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [productDetails, setProductDetails] = useState<ProductSummaryTypes>()
  const customerInfo = useAppSelector(customerInfoData)
  const storeState = useAppSelector(homePageData)
  const dispatch = useAppDispatch()
  dayjs.extend(isBetween)
  dayjs.extend(isToday)
  const deadline = () => {
    return dayjs(specialToDate).toString()
  }
  const tailLayout = {
    wrapperCol: {
      offset: 21,
      span: 16
    }
  }

  const onCountdownFinish = () => {
    if (dayjs(specialToDate).subtract(24, 'hour').hour() > 0) {
      return dayjs().add(24, 'hour').format()
    }

    return dayjs().add(+dayjs(specialToDate), 'millisecond').format()
  }

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
  }

  useEffect(() => {
    setItems(props.items)
  }, [props.items, customerInfo.customerId])

  const handleCancel = (e) => {
    setIsModalVisible(false)

    setProductDetails(null)
    e.stopPropagation()
  }

  const onFinish = async (value) => {
    const param = {
      customerId: customerInfo.customerId === 1 ? 1 : customerInfo.customerId,
      storeId: Number(localStorage.getItem('storeId')),
      productId: props.data.productId,
      quantity: value.items,
      skuId: productDetails.items[0].skuId,
      lang: { lang: localStorage.getItem('lang') }
    }
    dispatch(incrementShoppingCart(param))
    setProductDetails(null)
    dispatch(setItem({ itemId: props.data.productId, storeId: Number(localStorage.getItem('storeId')) }))
    setIsModalVisible(false)
  }

  const showProductPriceType = () => {
    if (specialStatus) {
      if (specialFromDate && specialToDate) {
        return (
          <Tag color='#ea3a3c'>
            <Countdown
              value={deadline()}
              valueStyle={{
                color: 'white',
                width: '44px',
                fontSize: '12px',
                overflow: 'hidden'
              }}
              onFinish={onCountdownFinish}
              format='HH:mm:ss -DD/MM/YYYY'
              style={{ display: 'flex', alignItems: 'center', height: '100%' }}
            />
          </Tag>
        )
      } else {
        return (
          <Tag color='#ea3a3c'>
            <FormattedMessage id='specialPrice' />
          </Tag>
        )
      }
    } else if (breakingStatus) {
      return (
        <Tag color='#ea3a3c'>
          <FormattedMessage id='wholesale' />
        </Tag>
      )
    } else if (stockVisible) {
      return (
        <Tag color='#ea3a3c'>
          <FormattedMessage id='limited' />
        </Tag>
      )
    } else {
      return <></>
    }
  }

  const stockStatus = () => {
    if (stockVisible > 0) {
      if (stock > 0) {
        if (stock < 10) {
          return (
            <>
              {stock} <FormattedMessage id='unit' />
            </>
          )
        } else {
          return <>{stock} <FormattedMessage id='unit' /></>
        }
      } else {
        return <FormattedMessage id='outOfStock' />
      }
    } else {
      return <></>
    }
  }

  const productTitle = () => {
    let title = 'PID:' + productId + ' ' + name
    tags && tags.map(x => title += ' ' + x)
    return title
  }

  const imageUrl = (img) => {
    let url = img
    if (!!img && (img.slice(0, 7) == 'http://' || img.slice(0, 8) == 'https://'))
      url = img
    else
      url = `${api.cdn}/${img}?x-oss-process=style/640w`
    return url
  }
  return (
    <StyledContent>
      <Badge
        overflowCount={99}
        offset={[-7, 7]}
        count={
          items.filter((i) => {
            return i.productInfo?.productId === props.data.productId
          }).length > 0
            ? items
              .filter((i) => {
                return i.productInfo?.productId === props.data.productId
              })
              .reduce((previousValue, currentValue) => previousValue + currentValue.quantity, 0)
            : null
        }
        size='default'
      >
        <Card
          style={{ minHeight: '100%', maxWidth: '100%' }}
          hoverable
          bordered={false}
          styles={{ body: { width: '100%', paddingTop: '0px', paddingRight: '5px', paddingLeft: '5px', paddingBottom: '5px'} }}
          cover={
            <StyledCover>
              <div style={{ display: 'flex', paddingLeft: '5px', paddingTop: '5px' }}>{showProductPriceType()}</div>
              <Tooltip title={productTitle}>
                <Img
                  preview={false}
                  src={`${imageUrl(image)}`}
                  fallback='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=='
                /></Tooltip>
            </StyledCover>
          }
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <ProductName>{name}</ProductName>
            <Sku>{barcode}</Sku>
            <Row align='middle' style={{ justifyContent: 'space-between' }}>
              <Col flex={1}>
                <H6PriceSymbol>$</H6PriceSymbol>
                {finalPriceType === "group" ? <H6PriceVIP>{finalPrice.toFixed(2)}</H6PriceVIP> : null}
                {finalPriceType === "wholesale" ? <H6PriceWholesale>{finalPrice.toFixed(2)}</H6PriceWholesale> : null}
                {finalPriceType === "special" ? <H6PriceSpecial>{finalPrice.toFixed(2)}</H6PriceSpecial> : null}
                {finalPriceType === "origin" ? <H6Price>{finalPrice.toFixed(2)}</H6Price> : null}
                {finalPriceType === "tier" ? <H6PriceTier>{finalPrice.toFixed(2)}</H6PriceTier> : null}
                {finalPriceType === "partner" ? <H6Price>{finalPrice.toFixed(2)}</H6Price> : null}
                {priceUnderlined > 0 ? <del style={{ fontSize: '0.7rem', color: 'gray' }}>${priceUnderlined.toFixed(2)}</del> : null}
              </Col>
              <Col><InfoCircleIconStyle
                onClick={async (e) => {
                  e.stopPropagation()
                  const productRes = await productSummary(productId, { customerId: customerInfo.customerId })
                  if (productRes.success) {
                    setProductDetails(productRes.data)
                    setIsModalVisible(true)
                  } else {
                    message.error(productRes.message)
                  }
                }}
              /></Col>
            </Row>
          </div>
        </Card>
      </Badge>
      <div
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Modal
          centered
          open={isModalVisible}
          destroyOnClose={true}
          footer={null}
          onCancel={handleCancel}
          title={<p style={{ marginTop: '20px' }}>{shippingName}</p>}
          styles={{ body: { maxHeight: '40rem', overflowY: 'auto' } }}
          width='80%'
        >
          <Form {...layout} onFinish={onFinish} validateMessages={validateMessages}>
            {productDetails?.typeId === 'simple' && (
              <Form.Item>
                <Form.Item
                  label={<FormattedMessage id='itemsOrder' />}
                  name='items'
                  rules={[
                    {
                      type: 'number',
                      min: productDetails.items[0].unitMax
                        ? productDetails.items[0].unitMin === 1
                          ? 1
                          : productDetails.items[0].unitMin
                        : 1,
                      max: productDetails.items[0].unitMax
                        ? productDetails.items[0].unitMax === 0
                          ? Number.MAX_VALUE
                          : productDetails.items[0].unitMax
                        : Number.MAX_VALUE
                    }
                  ]}
                >
                  <InputNumber autoFocus />
                </Form.Item>
                <span style={{ position: 'absolute', top: '4px', left: '150px' }}>
                  <FormattedMessage id='max' />:{' '}
                  {productDetails.items[0].unitMax ? (
                    productDetails.items[0].unitMax === 0 ? (
                      <FormattedMessage id='infinity' />
                    ) : (
                      productDetails.items[0].unitMax
                    )
                  ) : (
                    <FormattedMessage id='infinity' />
                  )}
                </span>
              </Form.Item>
            )}
            {productDetails?.typeId === 'grouped' ? (
              productDetails.groupedProducts.map((product) => {
                return (
                  <div key={product.productId}>
                    <p>{product.shippingName}</p>
                    <Table rowKey='skuId' size='small' columns={productInventoryColumns} dataSource={product?.items} />
                  </div>
                )
              })
            ) : productDetails?.typeId === 'variant' ? (
              <Table rowKey='skuId' size='small' columns={productInventoryColumns} dataSource={productDetails?.items} />
            ) : productDetails?.typeId === 'bundle' ? (
              <>
                {
                  <div>
                    <p style={{ fontSize: '1rem', fontWeight: 'bold' }}>{productDetails.shippingName}</p>
                    <Table rowKey='skuId' size='small' columns={productInventoryColumns} dataSource={productDetails.items} />
                  </div>
                }
                {productDetails.bundledOptions.map((item) => {
                  return (
                    <div key={item.id} style={{ marginLeft: '25px' }}>
                      <p style={{ fontSize: '1rem', fontWeight: 'bold' }}>{item.title}</p>
                      {item.selections.map((select) => {
                        return (
                          <div key={select.id} style={{ marginLeft: '1.5rem' }}>
                            {select.product.items.map((product) => {
                              return (
                                <div key={product.skuId}>
                                  <p>{select.product.shippingName}</p>
                                  <Table rowKey='skuId' size='small' columns={productInventoryColumns} dataSource={select.product?.items} />
                                </div>
                              )
                            })}
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
              </>
            ) : (
              <Table rowKey='skuId' size='small' columns={productInventoryColumns} dataSource={productDetails?.items || []} />
            )}
            {productDetails?.typeId === 'simple' && (
              <Form.Item {...tailLayout}>
                <Button type='primary' htmlType='submit'>
                  <FormattedMessage id='submit' />
                </Button>
              </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    </StyledContent>
  )
}

export default Products
